import { fileManagementRoutes } from "./fileManagement-routes";

export default (router: any) => {
  fileManagementRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
